var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluetooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(-366 -635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_37",
    "data-name": "Rect\\xE1ngulo 37",
    width: 18,
    height: 18,
    transform: "translate(366 635)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "baseline-bluetooth-audio",
    d: "M9.476,7.767,10.812,9.1a3.707,3.707,0,0,0,.253-1.342,3.766,3.766,0,0,0-.248-1.331Zm3.048-3.053-.726.726a4.986,4.986,0,0,1,.565,2.316,5.04,5.04,0,0,1-.565,2.316l.691.691a5.694,5.694,0,0,0,.035-6.049Zm-2.2.576L7.033,2H6.457V6.373L3.812,3.728,3,4.541,6.221,7.761,3,10.982l.812.812L6.457,9.15v4.373h.576l3.29-3.29L7.845,7.761,10.323,5.29ZM7.609,4.207,8.692,5.29,7.609,6.373Zm1.083,6.026L7.609,11.316V9.15l1.083,1.083Z",
    transform: "translate(367 636)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.330b85b97c6929e47942d0885618b97b.svg";
export { ForwardRef as ReactComponent };